// /*=========================================================================================
//   File Name: sidebarItems.js
//   Description: Sidebar Items list. Add / Remove menu items from here.
//   ----------------------------------------------------------------------------------------
//   Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
//   Author: Pixinvent
//   Author URL: http://www.themeforest.net/user/pixinvent
// ==========================================================================================*/


export default [
  {
    url: "/dashboard",
    name: "dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    i18n: "dashboard",
    rule: "organization"
  },
  // {
  //   url: '/user/overview',
  //   name: "dashboard",
  //   slug: "dashboard",
  //   icon: "HomeIcon",
  //   i18n: "dashboard",
  //   rule: "organization"
  // },
  {
    name:'project',
    slug:'project',
    icon:'FolderPlusIcon',
    i18n:'project',
    rule: "organization",
    submenu: [
      {
        url:"/user/v2/project-list",
        slug: "projectList",
        name: "projectList",
        icon: "FolderPlusIcon",
        i18n: "projectList",
        rule: "organization"
      },
      {
        url:"/user/v2/create-new-project",
        slug: "createProject",
        name: "createProject",
        icon: "FolderPlusIcon",
        i18n: "createProject",
        rule: "organization"
      },
    ]
  },
  {
    header: 'tool',
    icon: 'ToolIcon',
    i18n: 'tool',
    rule: 'organization',
    items: [
      {
        url: "/user/dashboard-v2",
        name: "statistics",
        slug: "statistics",
        icon: "BarChart2Icon",
        i18n: "statistics",
        rule: "organization",
      },
      // {
      //   url: "/user/v2/demo-graphic",
      //   name: "demoGraphic",
      //   slug: "demoGraphic",
      //   icon: "PieChartIcon",
      //   i18n: "demoGraphic",
      //   rule: "organization",
      // },
      {
        name: "news",
        slug: "special",
        icon: "FileTextIcon",
        i18n: "news",
        rule: "organization",
        cursor : "pointer",
        submenu : [
          {
            url:"/user/article-details-v2",
            name: "isDetail",
            slug: "special",
            icon: "StarIcon",
            i18n: "articlesByTopic",
            rule: "organization"
          },
          {
            url:"/user/article-timeline",
            name: "Time-Line",
            slug: "special",
            icon: "StarIcon",
            i18n: "timeline",
            rule: "organization"
          },
          {
            url:"/user/article-specials",
            name: "isBookMark",
            slug: "special",
            icon: "StarIcon",
            i18n: "isBookMark",
            rule: "organization"
          },
          {
            url:"/user/article-spam",
            name: "isSpam",
            slug: "special",
            icon: "StarIcon",
            i18n: "isSpam",
            rule: "organization"
          }
        ]
      },
      {
        url: "/user/compare-branding",
        name: "compare",
        slug: "compare-article",
        icon: "FramerIcon",
        i18n: "compare",
        rule: "organization",
      },
      {
        name: "report",
        slug: "special",
        icon: "FileTextIcon",
        i18n: "report",
        rule: "organization",
        cursor : "pointer",
        submenu : [
          {
            url:"/user/v2/report-list",
            name: "reportList",
            slug: "special",
            icon: "StarIcon",
            i18n: "reportList",
            rule: "organization"
          },
          {
            url:"/user/v2/report-calendar-list",
            name: "reportCalendarList",
            slug: "special",
            icon: "StarIcon",
            i18n: "reportCalendarList",
            rule: "organization"
          },
          {
            url:"/user/v2/export-file",
            name: "exportFileReport",
            slug: "special",
            icon: "StarIcon",
            i18n: "exportFileReport",
            rule: "organization"
          },
          {
            url:"/user/v2/report-calendar",
            name: "reportCalendar",
            slug: "special",
            icon: "StarIcon",
            i18n: "reportCalendar",
            rule: "organization"
          },
        ]
      },
      {
        url: '/user/social-trending',
        name:'trending',
        slug: 'Trending',
        icon: 'TrendingUpIcon',
        i18n: 'trending',
        rule: "organization"
      },
      {
        url: '/user/v2/share-of-voice',
        name: 'Share of voice',
        slug: 'Trending',
        icon: 'RadioIcon',
        i18n: 'Share of voice',
        rule: "organization"
      },
      {
        url: '/user/v2/hashtag',
        name: 'Hashtag',
        slug: 'hashtag',
        icon: 'HashIcon',
        i18n: 'Hashtag',
        rule: "organization"
      }
    ]
  },
  {
    header: "manager",
    icon: "PackageIcon",
    i18n: "manager",
    rule: 'admin',
    items: [
      // {
      //   url: "/admin/manage-user",
      //   name: "managerUsersAdmin",
      //   slug: "manage-user",
      //   icon: "UserIcon",
      //   i18n: "managerUsers",
      // },
      {
        url: "/admin/article-chart",
        name: "manageArticleSpread",
        slug: "PieChartIcon",
        icon: "PieChartIcon",
        i18n: "manageArticleSpread",
      },
      {
        url: "/admin/newspaper/manage",
        name: "manageNewspaper",
        slug: "manage-newspaper",
        icon: "GlobeIcon",
        i18n: "manageNewspaper",
      },
      {
        url: "/admin/admin-article",
        name: "manageArticle",
        slug: "manageArticle",
        icon: "SaveIcon",
        i18n: "manageArticle",
      },
      {
        name: "manage-system",
        slug: "manage-system",
        icon: "AirplayIcon",
        i18n: "manageSystem",
        submenu : [
          {
            url: "/admin/worker-manage",
            name: "manageWorker",
            slug: "manageWorker",
            i18n: "manageWorker",
          },
          {
            url: "/admin/check-config",
            name: "checkConfig",
            slug: "checkConfig",
            i18n: "checkConfig",
          },
        ]
      },
      {
        url: "/admin/spread-article",
        name: "manageSpread",
        slug: "manageSpread",
        icon: "ActivityIcon",
        i18n: "manageSpread",
      },
      {
        url: "/admin/article-spread-table",
        name: "spreadTable",
        slug: "TrelloIcon",
        icon: "TrelloIcon",
        i18n: "spreadTable",
      },
      // {
      //   url: "/admin/manage-package",
      //   name: "managerPackages",
      //   slug: "manage-newspaper",
      //   icon: "PackageIcon",
      //   i18n: "managerPackages",
      // },
      // {
      //   url: "/admin/package/manage",
      //   name: "registerPackage",
      //   slug: "SaveIcon",
      //   icon: "SaveIcon",
      //   i18n: "registerPackage",
      // },
      // {
      //   url:"/page/facebook/manage",
      //   name: "createSourceDataFb",
      //   slug: "manage-facebook",
      //   icon: "FacebookIcon",
      //   i18n: "createSourceDataFb"
      // },
      // {
      //   url:"/page/website/manage",
      //   name: "createSourceDataWebsite",
      //   slug: "manage-website",
      //   icon: "ChromeIcon",
      //   i18n: "createSourceDataWebsite"
      // },
      // {
      //   url:"/admin/trial-job",
      //   name: "trialJobMange",
      //   slug: "manage-website",
      //   icon: "ChromeIcon",
      //   i18n: "trialJobMange"
      // },
      // // {
      // //   url:'/admin/account-views',
      // //   name: 'managerUsers',
      // //   slug:'Manager-account',
      // //   icon:'UserIcon',
      // //   i18n:'managerUsers'
      // // },
      // {
      //   url:'/admin/realtime-chart',
      //   name: 'dataSourceTracking',
      //   slug:'Realtime-data',
      //   icon:'DatabaseIcon',
      //   i18n:'dataSourceTracking'
      // },
      // {
      //   url:'/admin/widget',
      //   name: 'widget',
      //   slug:'widget',
      //   icon:'LayersIcon',
      //   i18n:'Widget'
      // }
    ]
  },
  {
    header: "manager",
    icon: "PackageIcon",
    i18n: "manager",
    rule: 'contributor',
    items: [
      {
        url: "/contributor/manage-user",
        name: "managerUsersAdmin",
        slug: "manage-user",
        icon: "UserIcon",
        i18n: "managerUsers",
      }
    ]
  },
  // {
  //   header: "functionList",
  //   icon: "PackageIcon",
  //   i18n: "functionList",
  //   rule: 'admin',
  //   items: [
  //     {
  //       url: "/admin/manage-permission",
  //       name: "limitFunction",
  //       slug: "manage-permission",
  //       icon: "BriefcaseIcon",
  //       i18n: "limitFunction",
  //     }
  //   ]
  // },
  {
    header: "manager",
    icon: "ServerIcon",
    i18n: "manager",
    rule: 'organization',
    items: [
      {
        name: "warnings",
        url: "#",
        icon: "BellIcon",
        i18n: "warnings",
        rule: "organization",
        submenu : [
          {
            url: '/user/warning-manager',
            slug: 'Warning-notify',
            name: 'messageWarning',
            i18n: 'messageWarning',
            rule: 'organization'
          },
          {
            url:"/user/warning-v2",
            slug: "special",
            name: "listWarnings",
            i18n: "listWarnings",
            rule: "organization"
          },
          {
            url: '/user/create-warning-v2',
            slug: 'Warning-create',
            name: 'warning.createWarning',
            i18n: 'warning.createWarning',
            rule: 'organization'
          }
        ]
      },
      // {
      //   url:"/user/manager-keyword",
      //   name: "managerKeywords",
      //   slug: "special",
      //   icon: "ToolIcon",
      //   i18n: "managerKeywords",
      //   rule: "organization"
      // },
      // {
      //   url:"/user/account-user",
      //   name: "managerUsers",
      //   slug: "special",
      //   icon: "UserIcon",
      //   i18n: "managerUsers",
      //   rule: "organization"
      // },
      // {
      //   name: "managerPackages",
      //   url: "#",
      //   icon: "PackageIcon",
      //   i18n: "managerPackages",
      //   rule: "organization",
      //   submenu : [
      //     {
      //       url:"/user/package/upgrade",
      //       slug: "special",
      //       name: "registerPackage",
      //       icon: "StarIcon",
      //       i18n: "registerPackage",
      //       rule: "organization"
      //     },
      //     {
      //       url:"/user/package-detail",
      //       name: "packageDetail",
      //       slug: "special",
      //       icon: "StarIcon",
      //       i18n: "packageDetail",
      //       rule: "organization"
      //     },
      //     {
      //       url:"/user/package/manage",
      //       name: "historyRequest",
      //       slug: "special",
      //       icon: "StarIcon",
      //       i18n: "historyRequest",
      //       rule: "organization"
      //     },

      //   ]
      // },
      {
        name: "sourceData",
        slug: "special",
        icon: "PlusSquareIcon",
        i18n: "sourceData",
        rule: "organization",
        submenu : [
          {
            url:"/user/source-facebook",
            name: "listSourceFb",
            slug: "special",
            i18n: "listSourceFb",
            rule: "organization"
          },
          {
            url:"/user/source-article",
            name: "listSourceWebsite",
            slug: "special",
            i18n: "listSourceWebsite",
            rule: "organization"
          },
        //   // {
        //   //   url:"/page/facebook/manage",
        //   //   name: "createSourceDataFb",
        //   //   slug: "special",
        //   //   icon: "StarIcon",
        //   //   i18n: "createSourceDataFb",
        //   //   rule: "organization"
        //   // },
        //   // {
        //   //   url:"/page/website/manage",
        //   //   name: "createSourceDataWebsite",
        //   //   slug: "special",
        //   //   icon: "StarIcon",
        //   //   i18n: "createSourceDataWebsite",
        //   //   rule: "organization"
        //   // },
        //   // {
        //   //   url:"/user/classify-source",
        //   //   name: "Thêm nguồn dữ liệu",
        //   //   slug: "Article",
        //   //   icon: "PackageIcon",
        //   //   i18n: "PackageIcon",
        //   //   rule: "organization"
        //   // }
        ]
      },
      {
        name: "settings",
        slug: "special",
        icon: "SettingsIcon",
        i18n: "settings",
        rule: "organization",
        cursor : "pointer",
        submenu : [
          {
            url:"/user/personal-account-v2",
            name: "personalAccount",
            slug: "special",
            icon: "StarIcon",
            i18n: "personalAccount",
            rule: "organization"
          },
          {
            url:"/user/group-account-v2",
            name: "groupAccount",
            slug: "special",
            icon: "StarIcon",
            i18n: "groupAccount",
            rule: "organization"
          },
          {
            url:"/user/package-upgrade-v2",
            name: "packageData",
            slug: "Package",
            i18n: "packageData",
            rule: "organization"
          },
          // {
          //   url:"/user/v2/invoice",
          //   name: "Hoá đơn",
          //   slug: "generalSetting",
          //   icon: "StarIcon",
          //   i18n: "Hoá đơn",
          //   rule: "organization"
          // },
          // {
          //   url:"/user/v2/invoice-info",
          //   name: "Danh sách hoá đơn",
          //   slug: "generalSetting",
          //   icon: "StarIcon",
          //   i18n: "Danh sách hoá đơn",
          //   rule: "organization"
          // },
          {
            url:"/user/setting-general",
            name: "generalSetting",
            slug: "generalSetting",
            icon: "StarIcon",
            i18n: "generalSetting",
            rule: "organization"
          },
        ]
      },
    ]
  },
  {
    header: "other",
    icon: "ServerIcon",
    i18n: "other",
    rule: 'organization',
    items: [
      {
        name: "trialDashboard",
        url:"/page/trial-popup",
        slug: "special",
        icon: "DatabaseIcon",
        i18n: "trialDashboard",
        rule: "organization",
        cursor : "pointer",
      },
    ]
  },
]
